import stringify from 'fast-json-stable-stringify';
import { gzip } from 'fflate';
import type { GQLExtension } from '../../../web-client/graphql/types';

export const getEncodedAppContext = async (extension: GQLExtension): Promise<string> => {
	const { egress = [], overrides = {} } = extension;

	return gzipAndB64Encode({
		egress,
		overrides,
		hostname: window.location.hostname,
	});
};

const gzipAndB64Encode = (json: Record<string, any>): Promise<string> => {
	return new Promise((resolve, reject) => {
		const jsonString = stringify(json); // We use fast-json-stable-stringify to ensure that the JSON is deterministic

		gzip(
			new TextEncoder().encode(jsonString),
			{
				level: 9, // Max compression,
				mtime: 0, // We set the mtime to 0 to ensure that the output is deterministic
			},
			(err, result) => {
				if (err) {
					reject(err);
				} else {
					resolve(btoa(String.fromCharCode(...result)));
				}
			},
		);
	});
};
